import { Id } from '@order-management/types';
import { useCallback } from 'react';
import { Element } from 'react-bulma-components';
import InfiniteTable, {
  CustomInfiniteTableProps,
} from '../../ui/table/infinite-table/infinite-table';
import { Column } from '../../ui/table/types';

export type AdminTableProps<T extends Id, K = unknown> = Omit<
  CustomInfiniteTableProps<T>,
  'empty'
> & {
  columns: Column<T, K>[];
  emptyText?: string;
};

export function AdminTable<T extends Id, K = unknown>({
  columns,
  emptyText = 'There are no rows at the moment',
  ...tableProps
}: AdminTableProps<T, K>) {
  const EmptyTable = useCallback(
    () => (
      <Element
        display="flex"
        justifyContent="center"
        alignItems="center"
        className="h-full"
      >
        <span className="has-text-weight-light">{emptyText}</span>
      </Element>
    ),
    [emptyText]
  );

  return (
    <InfiniteTable
      {...tableProps}
      columns={columns as Column<T, unknown>[]}
      rowKey="id"
      empty={<EmptyTable />}
    />
  );
}

export default AdminTable;
